<div class="progress-container" [ngClass]="{ 'show-bg': showBackground }">
  <mat-spinner [diameter]="size" [style.--mdc-circular-progress-active-indicator-color]="'#3966b6'"></mat-spinner>
  <span *ngIf="text" class="progress-text"> {{ text }} </span>
</div>
